import { useState, useEffect } from "react";
import axios from "axios";
import {
    GridItem,
    Grid,
    useToast
} from "@chakra-ui/react";
import DesignationForm from "../components/DesignationForm";
import { CONFIG } from "../utils/constants";
import React from "react";
import DesignationsList from "../components/DesignationsList";
import { useSelector } from "react-redux";

export default function Designations() {
    const [designations, setDesignations] = useState([]);
    const toast = useToast();
    const isAdmin = useSelector((state: any) => state.user.is_admin);
    const token = localStorage.getItem(CONFIG.TOKEN_KEY);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const fetchData = async () => {
        const result = await axios.get(`${CONFIG.API_URL}/designations`);
        setDesignations(result.data.data);
    };

    useEffect(() => {
        fetchData();
    }, []);

    function handleDesignationAdd() {
        toast({
            position: 'top-right',
            title: 'Designation added successfully',
            status: 'success',
            duration: 3000,
            isClosable: true
        });
        fetchData();
    }

    function onDesignationDelete() {
        fetchData();
    }

    return (
        isAdmin ?
            <Grid py={5} gap={5} templateColumns={'350px 1fr'}>
                <GridItem>
                    <DesignationForm onDesignationAdd={handleDesignationAdd} />
                </GridItem>
                <GridItem>
                    <DesignationsList designations={designations} onItemDelete={onDesignationDelete}></DesignationsList>
                </GridItem>
            </Grid>
            :
            <DesignationsList designations={designations} onItemDelete={onDesignationDelete}></DesignationsList>

    );
}